function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { default as ReactSelect, components } from "react-select";
import VerifiedIcon from "@mui/icons-material/Verified";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useThemeContext } from "../../contexts/ThemeContext";
import { brandPrimary } from "../../constants";
var tKey = "components.react-select.Select";
var customControlStyles = function customControlStyles(base, state, theme, muiTheme) {
  var controlStyle = {
    boxShadow: state.isFocused ? "0 0 0 1px ".concat(brandPrimary) : 0,
    backgroundColor: "transparent",
    borderColor: state.isFocused ? brandPrimary : theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)",
    "&:hover": {
      borderColor: state.isFocused ? brandPrimary : theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"
    }
  };
  if (muiTheme.overrides.Select && muiTheme.overrides.Select.controlStyles) controlStyle = _objectSpread(_objectSpread({}, controlStyle), muiTheme.overrides.Select.controlStyles);
  return controlStyle;
};
var customInputStyles = function customInputStyles(state) {
  return {
    color: state.isDisabled ? "hsl(0, 0%, 60%)" : "inherit"
  };
};
var customDropdownIndicatorStyle = {
  color: brandPrimary
};
var customOptionStyle = function customOptionStyle(base, state, theme) {
  return {
    color: "inherit",
    backgroundColor: (state.isFocused || state.isSelected) && theme === "dark" && "rgb(255, 255, 255, 0.08)" || (state.isFocused || state.isSelected) && theme === "light" && "rgb(0, 0, 0, 0.08)" || base.backgroundColor,
    ":active": "none"
  };
};
var customSingleValueStyle = function customSingleValueStyle(state) {
  return {
    color: state.isDisabled ? "hsl(0, 0%, 60%)" : "inherit"
  };
};
var customMultiValueStyle = function customMultiValueStyle(theme) {
  return {
    backgroundColor: theme === "dark" ? "black" : "white",
    border: "1px solid rgb(51, 54, 57)"
  };
};
var customMenuStyle = function customMenuStyle(theme, muiTheme) {
  var menuStyle = {
    backgroundColor: theme === "dark" ? "black" : "white",
    border: theme === "dark" ? "1px solid rgb(51, 54, 57)" : "none",
    zIndex: 9999
  };
  if (muiTheme.overrides.Select && muiTheme.overrides.Select.menuStyle) menuStyle = _objectSpread(_objectSpread({}, menuStyle), muiTheme.overrides.Select.menuStyle);
  return menuStyle;
};
var customStyles = function customStyles(theme, muiTheme) {
  return {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), customControlStyles(base, state, theme, muiTheme));
    },
    input: function input(base, state) {
      return _objectSpread(_objectSpread({}, base), customInputStyles(state));
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), customDropdownIndicatorStyle);
    },
    option: function option(base, state) {
      return _objectSpread(_objectSpread({}, base), customOptionStyle(base, state, theme));
    },
    singleValue: function singleValue(base, state) {
      return _objectSpread(_objectSpread({}, base), customSingleValueStyle(state));
    },
    multiValue: function multiValue(base, state) {
      return _objectSpread(_objectSpread({}, base), customMultiValueStyle(theme));
    },
    menu: function menu(base, state) {
      return _objectSpread(_objectSpread({}, base), customMenuStyle(theme, muiTheme));
    },
    // Fixes the overlapping problem of the component
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props, verified, searchable) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, verified && /*#__PURE__*/React.createElement(VerifiedIcon, null) || searchable && /*#__PURE__*/React.createElement(SearchIcon, null) || /*#__PURE__*/React.createElement(KeyboardArrowDownIcon, null));
};
function Select(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme,
    muiTheme = _useThemeContext.muiTheme;
  return /*#__PURE__*/React.createElement(ReactSelect, _extends({
    placeholder: t("".concat(tKey, ".placeholder")),
    isDisabled: props.verified
  }, props, {
    isSearchable: props.searchable,
    styles: customStyles(theme, muiTheme),
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: function DropdownIndicator(props2) {
        return CustomDropdownIndicator(props2, props.verified, props.searchable);
      }
    }, props.components)
  }));
}
export default Select;
Select.defaultProps = {
  verified: false,
  searchable: true
};
Select.propTypes = {
  verified: PropTypes.bool,
  searchable: PropTypes.bool
};